import { Link } from "react-router-dom";
import { CALCULATOR_LIST } from "../../content/calculators";

export const Footer = () => (
  <footer className="mt-24 border-t border-border bg-background">
    <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-4">
      <div className="md:col-span-1">
        <div className="font-display text-lg font-bold tracking-tight">ProfitMigo</div>
        <p className="mt-3 text-sm text-muted-foreground">
          Calculate your costs. Set your price. Know your real profit.
        </p>
      </div>

      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Calculators</div>
        <ul className="mt-4 space-y-2 text-sm">
          {CALCULATOR_LIST.map((c) => (
            <li key={c.slug}>
              <Link to={c.path} className="text-foreground/80 hover:text-primary" data-testid={`footer-link-${c.slug}`}>
                {c.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Company</div>
        <ul className="mt-4 space-y-2 text-sm">
          <li><Link to="/about" className="text-foreground/80 hover:text-primary">About</Link></li>
          <li><Link to="/pricing" className="text-foreground/80 hover:text-primary">Pricing</Link></li>
          <li><Link to="/contact" className="text-foreground/80 hover:text-primary">Contact</Link></li>
          <li><Link to="/guides" className="text-foreground/80 hover:text-primary">Guides</Link></li>
        </ul>
      </div>

      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Legal</div>
        <ul className="mt-4 space-y-2 text-sm">
          <li><Link to="/privacy" className="text-foreground/80 hover:text-primary">Privacy Policy</Link></li>
          <li><Link to="/terms" className="text-foreground/80 hover:text-primary">Terms</Link></li>
          <li><Link to="/disclaimer" className="text-foreground/80 hover:text-primary">Disclaimer</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="mx-auto max-w-6xl px-4 py-6 text-xs text-muted-foreground sm:px-6">
        © {new Date().getFullYear()} ProfitMigo. Calculations are estimates — verify important financial decisions independently. Marketplace fees can change.
      </div>
    </div>
  </footer>
);
